export enum FilterType { Enum = 'Enum', Slider = 'Slider', Boolean = 'Boolean', Array = 'Array' }
